import { gql } from '@apollo/client';

// GraphQL Query
export const GET_CONTACT_MARKETING = gql`
  query GetContactMarketing($id: ID!) {
    node(id: $id) {
      ... on ContactNode {
        id
        name
        marketingPreferencesIds {
          id
          addToMediaContactMarketingList
          mediaContact
          marketingOnly
          charityEventList
          greenwichEvents
          isCanadian
          paddleEvents
          pamBeachCountyCommunity
          smcCareerOpportunityInterest
          smcfAdvisor
          smcSeniorAdvisor
          starMountainFullTimeTeam
          tiger21Member
          ypoMember
          ypoOptIn
          ypoOptInDate
          hbsOpm
          hbsOpmOptInDate
          brettHickeyPhysicalHolidayCardList
          brettsBirthdayInvitationList
          quarterlyFriendsDinner
          bhOutlookSync
          bhHomeEntertainment
          foodAllergiesDietaryRestrictions
          pmiExcludeFromInvitations
          atlantaEventFeb21
          privateCreditEventFeb8
          emailBusinessEventsMidwest
          emailBusinessEventsNortheast
          emailBusinessEventsSouth
          emailBusinessEventsWest
          emailCharityEventsMidwest
          emailCharityEventsNortheast
          emailCharityEventsSouth
          emailCharityEventsWest
          emailBoardOfDirectorOpps
          emailConsultingAndAdvisoryOpps
          emailDirectEquityInvOpps
          emailDirectLendingInvOpps
          emailIncomeFundInvOpps
          emailSeeingAcquisitionOpps
          emailSponsorshipOpps
          emailFullTimeCareerOpps
          emailEducationalWebinars
          emailNews
          profileDone
          profileUpdateNeeded
          profileUrl
          evergreenCreditFund
          privateCreditEvent170208
          potentialFundIvInvestorsMarketingList
          lastDateIncludedInCampaign
        }
      }
    }
  }
`;

// UI Data Types
export interface ContactMarketingData {
  addToMediaContactMarketingList: boolean;
  atlantaEventFeb21: string;
  bhHomeEntertainment: string;
  bhOutlookSync: boolean;
  brettHickeyPhysicalHolidayCardList: boolean;
  brettsBirthdayInvitationList: boolean;
  charityEventList: boolean;
  emailBoardOfDirectorOpps: boolean;
  emailBusinessEventsMidwest: boolean;
  emailBusinessEventsNortheast: boolean;
  emailBusinessEventsSouth: boolean;
  emailBusinessEventsWest: boolean;
  emailCharityEventsMidwest: boolean;
  emailCharityEventsNortheast: boolean;
  emailCharityEventsSouth: boolean;
  emailCharityEventsWest: boolean;
  emailConsultingAndAdvisoryOpps: boolean;
  emailDirectEquityInvOpps: boolean;
  emailDirectLendingInvOpps: boolean;
  emailEducationalWebinars: boolean;
  emailFullTimeCareerOpps: boolean;
  emailIncomeFundInvOpps: boolean;
  emailNews: boolean;
  emailSeeingAcquisitionOpps: boolean;
  emailSponsorshipOpps: boolean;
  evergreenCreditFund: boolean;
  foodAllergiesDietaryRestrictions: string;
  greenwichEvents: boolean;
  hbsOpm: boolean;
  hbsOpmOptInDate: string;
  isCanadian: boolean;
  lastDateIncludedInCampaign: string;
  marketingOnly: boolean;
  mediaContact: boolean;
  paddleEvents: boolean;
  palmBeachCountyCommunity: boolean;
  pmiExcludeFromInvitations: string;
  potentialFundIvInvestorsMarketingList: boolean;
  privateCreditEvent170208: string;
  privateCreditEventFeb8: string;
  profileDone: boolean;
  profileUpdateNeeded: boolean;
  profileUrl: string;
  quarterlyFriendsDinner: boolean;
  smcCareerOpportunityInterest: boolean;
  smcfAdvisor: boolean;
  smcSeniorAdvisor: boolean;
  starMountainFullTimeTeam: boolean;
  tiger21Member: boolean;
  ypoMember: boolean;
  ypoOptIn: boolean;
  ypoOptInDate: string;
}

export interface ContactNodeWithMarketing {
  id: string;
  marketingPreferencesIds?:
    | MarketingPreferencesNode
    | MarketingPreferencesNode[]
    | null;
  name: string;
}

// API Response Types
export interface MarketingPreferencesNode {
  addToMediaContactMarketingList?: boolean | null;
  atlantaEventFeb21?: null | string;
  bhHomeEntertainment?: null | string;
  bhOutlookSync?: boolean | null;
  brettHickeyPhysicalHolidayCardList?: boolean | null;
  brettsBirthdayInvitationList?: boolean | null;
  charityEventList?: boolean | null;
  emailBoardOfDirectorOpps?: boolean | null;
  emailBusinessEventsMidwest?: boolean | null;
  emailBusinessEventsNortheast?: boolean | null;
  emailBusinessEventsSouth?: boolean | null;
  emailBusinessEventsWest?: boolean | null;
  emailCharityEventsMidwest?: boolean | null;
  emailCharityEventsNortheast?: boolean | null;
  emailCharityEventsSouth?: boolean | null;
  emailCharityEventsWest?: boolean | null;
  emailConsultingAndAdvisoryOpps?: boolean | null;
  emailDirectEquityInvOpps?: boolean | null;
  emailDirectLendingInvOpps?: boolean | null;
  emailEducationalWebinars?: boolean | null;
  emailFullTimeCareerOpps?: boolean | null;
  emailIncomeFundInvOpps?: boolean | null;
  emailNews?: boolean | null;
  emailSeeingAcquisitionOpps?: boolean | null;
  emailSponsorshipOpps?: boolean | null;
  evergreenCreditFund?: boolean | null;
  foodAllergiesDietaryRestrictions?: null | string;
  greenwichEvents?: boolean | null;
  hbsOpm?: boolean | null;
  hbsOpmOptInDate?: null | string;
  id: string;
  isCanadian?: boolean | null;
  lastDateIncludedInCampaign?: null | string;
  marketingOnly?: boolean | null;
  mediaContact?: boolean | null;
  paddleEvents?: boolean | null;
  pamBeachCountyCommunity?: boolean | null;
  pmiExcludeFromInvitations?: null | string;
  potentialFundIvInvestorsMarketingList?: boolean | null;
  privateCreditEvent170208?: null | string;
  privateCreditEventFeb8?: null | string;
  profileDone?: boolean | null;
  profileUpdateNeeded?: boolean | null;
  profileUrl?: null | string;
  quarterlyFriendsDinner?: boolean | null;
  smcCareerOpportunityInterest?: boolean | null;
  smcfAdvisor?: boolean | null;
  smcSeniorAdvisor?: boolean | null;
  starMountainFullTimeTeam?: boolean | null;
  tiger21Member?: boolean | null;
  ypoMember?: boolean | null;
  ypoOptIn?: boolean | null;
  ypoOptInDate?: null | string;
}

// Helper functions
export function createEmptyContactMarketingData(): ContactMarketingData {
  return {
    addToMediaContactMarketingList: false,
    atlantaEventFeb21: '',
    bhHomeEntertainment: '',
    bhOutlookSync: false,
    brettHickeyPhysicalHolidayCardList: false,
    brettsBirthdayInvitationList: false,
    charityEventList: false,
    emailBoardOfDirectorOpps: false,
    emailBusinessEventsMidwest: false,
    emailBusinessEventsNortheast: false,
    emailBusinessEventsSouth: false,
    emailBusinessEventsWest: false,
    emailCharityEventsMidwest: false,
    emailCharityEventsNortheast: false,
    emailCharityEventsSouth: false,
    emailCharityEventsWest: false,
    emailConsultingAndAdvisoryOpps: false,
    emailDirectEquityInvOpps: false,
    emailDirectLendingInvOpps: false,
    emailEducationalWebinars: false,
    emailFullTimeCareerOpps: false,
    emailIncomeFundInvOpps: false,
    emailNews: false,
    emailSeeingAcquisitionOpps: false,
    emailSponsorshipOpps: false,
    evergreenCreditFund: false,
    foodAllergiesDietaryRestrictions: '',
    greenwichEvents: false,
    hbsOpm: false,
    hbsOpmOptInDate: '',
    isCanadian: false,
    lastDateIncludedInCampaign: '',
    marketingOnly: false,
    mediaContact: false,
    paddleEvents: false,
    palmBeachCountyCommunity: false,
    pmiExcludeFromInvitations: '',
    potentialFundIvInvestorsMarketingList: false,
    privateCreditEvent170208: '',
    privateCreditEventFeb8: '',
    profileDone: false,
    profileUpdateNeeded: false,
    profileUrl: '',
    quarterlyFriendsDinner: false,
    smcCareerOpportunityInterest: false,
    smcfAdvisor: false,
    smcSeniorAdvisor: false,
    starMountainFullTimeTeam: false,
    tiger21Member: false,
    ypoMember: false,
    ypoOptIn: false,
    ypoOptInDate: ''
  };
}

export function mapContactMarketing(
  node: MarketingPreferencesNode
): ContactMarketingData {
  return {
    addToMediaContactMarketingList:
      node.addToMediaContactMarketingList ?? false,
    atlantaEventFeb21: node.atlantaEventFeb21 ?? '',
    bhHomeEntertainment: node.bhHomeEntertainment ?? '',
    bhOutlookSync: node.bhOutlookSync ?? false,
    brettHickeyPhysicalHolidayCardList:
      node.brettHickeyPhysicalHolidayCardList ?? false,
    brettsBirthdayInvitationList: node.brettsBirthdayInvitationList ?? false,
    charityEventList: node.charityEventList ?? false,
    emailBoardOfDirectorOpps: node.emailBoardOfDirectorOpps ?? false,
    emailBusinessEventsMidwest: node.emailBusinessEventsMidwest ?? false,
    emailBusinessEventsNortheast: node.emailBusinessEventsNortheast ?? false,
    emailBusinessEventsSouth: node.emailBusinessEventsSouth ?? false,
    emailBusinessEventsWest: node.emailBusinessEventsWest ?? false,
    emailCharityEventsMidwest: node.emailCharityEventsMidwest ?? false,
    emailCharityEventsNortheast: node.emailCharityEventsNortheast ?? false,
    emailCharityEventsSouth: node.emailCharityEventsSouth ?? false,
    emailCharityEventsWest: node.emailCharityEventsWest ?? false,
    emailConsultingAndAdvisoryOpps:
      node.emailConsultingAndAdvisoryOpps ?? false,
    emailDirectEquityInvOpps: node.emailDirectEquityInvOpps ?? false,
    emailDirectLendingInvOpps: node.emailDirectLendingInvOpps ?? false,
    emailEducationalWebinars: node.emailEducationalWebinars ?? false,
    emailFullTimeCareerOpps: node.emailFullTimeCareerOpps ?? false,
    emailIncomeFundInvOpps: node.emailIncomeFundInvOpps ?? false,
    emailNews: node.emailNews ?? false,
    emailSeeingAcquisitionOpps: node.emailSeeingAcquisitionOpps ?? false,
    emailSponsorshipOpps: node.emailSponsorshipOpps ?? false,
    evergreenCreditFund: node.evergreenCreditFund ?? false,
    foodAllergiesDietaryRestrictions:
      node.foodAllergiesDietaryRestrictions ?? '',
    greenwichEvents: node.greenwichEvents ?? false,
    hbsOpm: node.hbsOpm ?? false,
    hbsOpmOptInDate: node.hbsOpmOptInDate ?? '',
    isCanadian: node.isCanadian ?? false,
    lastDateIncludedInCampaign: node.lastDateIncludedInCampaign ?? '',
    marketingOnly: node.marketingOnly ?? false,
    mediaContact: node.mediaContact ?? false,
    paddleEvents: node.paddleEvents ?? false,
    palmBeachCountyCommunity: node.pamBeachCountyCommunity ?? false,
    pmiExcludeFromInvitations: node.pmiExcludeFromInvitations ?? '',
    potentialFundIvInvestorsMarketingList:
      node.potentialFundIvInvestorsMarketingList ?? false,
    privateCreditEvent170208: node.privateCreditEvent170208 ?? '',
    privateCreditEventFeb8: node.privateCreditEventFeb8 ?? '',
    profileDone: node.profileDone ?? false,
    profileUpdateNeeded: node.profileUpdateNeeded ?? false,
    profileUrl: node.profileUrl ?? '',
    quarterlyFriendsDinner: node.quarterlyFriendsDinner ?? false,
    smcCareerOpportunityInterest: node.smcCareerOpportunityInterest ?? false,
    smcfAdvisor: node.smcfAdvisor ?? false,
    smcSeniorAdvisor: node.smcSeniorAdvisor ?? false,
    starMountainFullTimeTeam: node.starMountainFullTimeTeam ?? false,
    tiger21Member: node.tiger21Member ?? false,
    ypoMember: node.ypoMember ?? false,
    ypoOptIn: node.ypoOptIn ?? false,
    ypoOptInDate: node.ypoOptInDate ?? ''
  };
}

// Choice options
export const bhHomeEntertainmentOptions = [
  { label: 'Not Invited', value: 'Not Invited' },
  { label: 'Regular Guest', value: 'Regular Guest' },
  { label: 'VIP Guest', value: 'VIP Guest' }
];

export const eventStatusOptions = [
  { label: 'Attended', value: 'Attended' },
  { label: 'Confirmed', value: 'Confirmed' },
  { label: 'Declined', value: 'Declined' },
  { label: 'Invited', value: 'Invited' },
  { label: 'Not Invited', value: 'Not Invited' },
  { label: 'Pending', value: 'Pending' }
];

export const foodAllergiesOptions = [
  { label: 'Dairy-Free', value: 'Dairy-Free' },
  { label: 'Gluten-Free', value: 'Gluten-Free' },
  { label: 'Halal', value: 'Halal' },
  { label: 'Kosher', value: 'Kosher' },
  { label: 'None', value: 'None' },
  { label: 'Nut Allergy', value: 'Nut Allergy' },
  { label: 'Other', value: 'Other' },
  { label: 'Vegan', value: 'Vegan' },
  { label: 'Vegetarian', value: 'Vegetarian' }
];

export const pmiExcludeOptions = [
  { label: 'All Invitations', value: 'All Invitations' },
  { label: 'Email Only', value: 'Email Only' },
  { label: 'None', value: 'None' },
  { label: 'Physical Only', value: 'Physical Only' }
];

export const yesNoOptions = [
  { label: 'No', value: 'No' },
  { label: 'Yes', value: 'Yes' }
];
